'use client'

import { PlaceholdersAndVanishInput } from '@/components/ui/placeholders-and-vanish-input'

const DEFAULT_PLACEHOLDERS = [
  'Search sections…',
  'Find rich text, cards, tabs…',
  'Try timeline, code, media…',
]

/**
 * Launchpad filter — vanish-input styling, search-only behavior.
 */
export function LaunchpadSearch({ onValueChange, placeholders = DEFAULT_PLACEHOLDERS }) {
  return (
    <div className="nb-launchpad-search-wrap">
      <PlaceholdersAndVanishInput
        searchMode
        autoFocus
        placeholders={placeholders}
        className="nb-launchpad-vanish-input"
        onChange={(e) => onValueChange(e.target.value)}
        onSubmit={(e) => e.preventDefault()}
      />
    </div>
  )
}
